export const applicationTypeToGetThisJobButtonText = {
    'APPLICATION': 'Apply for this job',
    'DIRECTINVITE': 'Get this job',
    'WAITLIST': 'Get this job',
}

export const applicationTypeNotForMeJobButtonText = {
    'APPLICATION': 'Not for me',
    'DIRECTINVITE': 'Reject direct invite',
    'WAITLIST': 'Not for me',
}